import { Avatar, Clickable, Col, Icon, Input, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { Api, theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const ChatItem = ({ user, navigate, handleClose, isMobile, setSelectedChat }) => {
  function handleClick() {
    navigate(`/messages/${user._id}`);
    setSelectedChat(user._id);
    handleClose();
  }

  return (
    <Clickable marg="12px 0 0" onClick={handleClick}>
      <Row wid={isMobile ? 'auto' : '326px'} ht="40px" center start pad="16px 0">
        <Avatar user={user} />

        <Col marg="0 0 0 12px" center>
          <Text b1 bold>
            {user.name}
          </Text>
          {user.bio && (
            <Text marg="2px 0 0" c2 col={theme.GREY_60}>
              {user.bio}
            </Text>
          )}
        </Col>
      </Row>
    </Clickable>
  );
};

let timer;
let scrolled = false;
const AddChat = ({ handleClose, setSelectedChat }) => {
  const [search, setSearch] = useState(''),
    [data, setData] = useState([]),
    [listEndReached, setListEndReached] = useState(false),
    modalRef = useRef(),
    scrollRef = useRef(),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    navigate = useNavigate();

  useOutsideClick(modalRef, handleClose);

  useEffect(() => {
    getUsers();

    scrollRef.current?.addEventListener('scroll', onScroll);
    return () => scrollRef.current?.removeEventListener('scroll', onScroll);
  }, []);

  async function handleSearch(text, searchNew) {
    setSearch(text);

    clearTimeout(timer);

    timer = setTimeout(async () => {
      setListEndReached(false);

      const res = await Api.post('/users/searchFriends', {
        text,
        skip: (!searchNew && data?.length) || 0
      });
      if (!res) return;
      if (!res?.length) return setListEndReached(true);

      setData(searchNew ? res : [...data, ...res]);
    }, 300);
  }

  async function onScroll(e) {
    if (scrolled) return;

    const bottomThreshold = e.target.scrollHeight - e.target.clientHeight,
      scrollHt = e.target.scrollTop + 200;

    if (scrollHt <= bottomThreshold && !scrolled) return;
    scrolled = true;

    (await !listEndReached) && handleSearch(search);
    scrolled = false;
  }

  async function getUsers() {
    const res = await Api.post('/users/searchFriends', { text: search });
    if (!res) return;

    setData(res);
  }

  return (
    <Col
      pos="fixed"
      left="0"
      top="72px"
      zIndex="4"
      wid="100vw"
      ht="calc(100vh - 72px)"
      bg="rgba(47, 47, 47, 0.8)"
      centerAll
    >
      <Col
        ref={modalRef}
        center
        hasRadius={isMobile ? '0' : '32px'}
        bg="#fff"
        pad="16px"
        ht={isMobile ? '100vh' : '650px'}
        noFlex
      >
        {isMobile && (
          <Row between marg="0 0 16px">
            <Row pos="relative" wid="0">
              <Clickable onClick={handleClose}>
                <Icon type="arrowLeft" dimensions={16} col={theme.GREY_60} />
              </Clickable>
            </Row>

            <Text b2 bold>
              {t('messages.addChat')}
            </Text>

            <Row />
          </Row>
        )}

        <Input
          search
          wid="calc(100% - 32px)"
          placeholder={t('messages.searchFriends')}
          value={search}
          onChange={(e) => handleSearch(e.target.value, true)}
        />

        <Col
          start
          style={{ overflowY: 'scroll' }}
          ref={scrollRef}
          wid={isMobile ? 'calc(100vw - 32px)' : '400px'}
        >
          {data.map((x, i) => (
            <ChatItem
              key={i}
              user={x}
              isMobile={isMobile}
              navigate={navigate}
              handleClose={handleClose}
              setSelectedChat={setSelectedChat}
            />
          ))}
        </Col>
      </Col>
    </Col>
  );
};

export default AddChat;
